import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRFittingBody,
  CRFittingBodyAPI,
  CRFittingKey,
  CRFittingSummary,
  CRFittingSummaryAPI,
  FittingsActions,
  FittingsState,
} from './types';

type AnyFitting = CRFittingKey | CRFittingSummary | CRFittingBody | undefined;

function sameKeyFitting(a: AnyFitting, b: AnyFitting): boolean {
  return a?.fittingId === b?.fittingId;
}

function getEndpointFitting(key: AnyFitting): string {
  return key ? `/fittings/${key?.fittingId}/` : '/fittings/';
}

function parseFittingSummary(
  fittingSummary: CRFittingSummaryAPI,
): CRFittingSummary {
  return fittingSummary;
}

function parseFittingBody(fittingDetail: CRFittingBodyAPI): CRFittingBody {
  return fittingDetail;
}

const fittingsStateSelector = (state: any): FittingsState => state.fittings;

const fittingsKeySelector = ({
  fittingId,
}: CRFittingBody | CRFittingSummary): CRFittingKey => ({ fittingId });

function mergeFittingBody(lastBody: CRFittingBody, currentBody: CRFittingBody) {
  return currentBody;
}

function combineSummaryBodyFitting(
  summary?: CRFittingSummary,
  body?: CRFittingBody,
): CRFittingSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    fittingId: merge('fittingId'),
    rowKey: merge('rowKey'),
    fittingName: merge('fittingName'),
    inUse: body?.inUse?.client.value ?? summary?.inUse,
  };
}

const { actions, reducer, watches, useListener } = createMainResourceREST(
  'fittings',
  getEndpointFitting,
  fittingsStateSelector,
  sameKeyFitting,
  parseFittingBody,
  parseFittingSummary,
  mergeFittingBody,
  combineSummaryBodyFitting,
);

const fittingsActions: FittingsActions = actions;
export * from './types';
export {
  fittingsActions,
  useListener as useFittingListener,
  reducer as fittingsReducer,
  watches as fittingsWatches,
  fittingsStateSelector,
  fittingsKeySelector,
  getEndpointFitting,
};
